import { Injectable } from '@angular/core';

import { EventModel, EventOption } from '@frontend/sports/betting-offer/feature/model';

import { BaseOptionGroupStatisticsService } from './base-option-group-statistics.service';

export interface StatisticsParams {
    optionGroupId?: string;
    playerName: string;
    key?: string;
    optionId?: string;
}

export interface IPlayerPropsOptionLine {
    playerId: number | undefined;
    playerName: string;
    overOption?: EventOption;
    underOption?: EventOption;
    showStats?: boolean;
}

@Injectable()
export class OptionGroupTeamStatisticsService extends BaseOptionGroupStatisticsService {
    toggleOpen(event: EventModel): void {
        const { data } = this.playerStatistics();

        if (!data) {
            this.fetchPlayerStatistics(event, '', true);
            return;
        }

        const isOpen = data.isMainMarketOpen;

        this.playerStatisticsService.openTeamStatistics({
            eventId: event.id,
            isMainMarketOpen: !isOpen,
            mainMarketTracking: isOpen,
            mainMarketLoadedTracking: isOpen,
        });
        return;
    }

    isOpen(): boolean {
        const state = this.playerStatistics();
        return !!state?.data?.isMainMarketOpen;
    }
}
